import React, { ReactNode, createContext, useContext, useState,  SetStateAction } from 'react';
import { DataItemProps } from '../ConfigurableLineChart.types';

interface Props {
  children?: ReactNode | ReactNode[];
  useProvidedSelector?: boolean;
}

export type ChartSelectorHistoryItemProps = Record<string, unknown> | undefined;
export type UseChartSelectorHandlerProps = (x?: Record<string, unknown>) => unknown;
export type UseChartSelectorReturnProps = [
  Record<keyof DataItemProps, (string | number | Date)[] | undefined> | undefined,
  React.Dispatch<SetStateAction<Record<keyof DataItemProps, (string | number | Date)[] | undefined> | undefined>>,
  boolean
];

export const useChartSelections = (): UseChartSelectorReturnProps =>
  useContext(ChartSelectionsContext);

export const UseChartSelectionsProvider = ({ children, useProvidedSelector }: Props): JSX.Element => {
  const [, providedInit] = useChartSelections();
  const [selected, setSelected] = useState<Record<keyof DataItemProps, (string | number | Date)[] | undefined> | undefined>(undefined);

  // return early if this is already wrapped in a provider
  if (!providedInit && useProvidedSelector === false) {
    return (
      <UseChartSelectionsProvider>
        {children}
      </UseChartSelectionsProvider>
    );
  }

  return (
    <ChartSelectionsContext.Provider value={[selected, setSelected, true]}>
      {children}
    </ChartSelectionsContext.Provider>
  );
};

const ChartSelectionsContext = createContext<UseChartSelectorReturnProps>([
  undefined,
  () => console.log('select not init' ),
  false
]);
